import React, { useState, useEffect } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import api from "../../api/api";

const ImageUploader = ({ onChange, initialMedia }) => {
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);

  const baseUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:1337"
      : window.location.hostname === "stageadmin.planium.ir"
      ? "https://stageapi.planium.ir"
      : window.location.hostname === "admin.planium.ir"
      ? "https://api.planium.ir"
      : window.location.hostname === "";

  useEffect(() => {
    if (initialMedia?.id) {
      setFileList([
        {
          uid: `${initialMedia.id}`,
          name: initialMedia.name,
          status: "done",
          url: baseUrl + initialMedia.url,
        },
      ]);
    }
  }, [initialMedia]);

  const handlePreview = (file) => {
    setPreviewImage(file.thumbUrl || file.url);
  };

  const handleChange = ({ fileList }) => {
    setFileList(fileList);
    if (fileList.length > 0 && !fileList[0].url) {
      handleUpload(fileList);
    }
  };

  const handleUpload = async (fileList) => {
    const formData = new FormData();
    if (fileList.length === 0) {
      return;
    }

    formData.append("uploadedFile", fileList[0].originFileObj);

    try {
      const response = await api.post("/media-manager/upload", formData);
      onChange("mediaId", response.data.id);
      message.success("آپلود انجام شد");
    } catch (err) {
      message.error("خطا در آپلود");
      console.error("Error uploading image", err);
    }
  };

  return (
    <div>
      <Upload
        listType="picture"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        beforeUpload={() => false}
        maxCount={1}
      >
        {fileList.length === 0 && (
          <Button icon={<UploadOutlined />}>انتخاب عکس</Button>
        )}
      </Upload>
    </div>
  );
};

export default ImageUploader;
